import { Json, LegacyPage } from 'peach/components'
import { truncateString } from 'peach/helpers'

import { useActiveEnvStorage } from 'core/stores/env'
import makeStorage from 'core/storage/makeStorage'

const Env = () => {
  const envStorage = useActiveEnvStorage()
  const storage = envStorage ?? makeStorage('__DEFAULT__')

  const { token, ...rest } = storage.getAll()

  const $token = truncateString(token)

  const result = { token: $token, ...rest }

  return (
    <LegacyPage.Full>
      <Json.Table json={result} title='Storage' />
    </LegacyPage.Full>
  )
}

export default Env
